import { createSlice } from '@reduxjs/toolkit';
import {
  uploadVehicleImage,
  fetchVehicleImages,
  editVehicleImage,
  removeVehicleImage,
  fetchVehicleImagesBrands
} from '../actions/vehicleImages-actions';

const initialState = {
  isLoadingImages: false,
  vehicleImages: [],
  vehicle: null,
};

const vehicleImageSlice = createSlice({
  name: 'vehicleImage',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchVehicleImages.pending, (state) => {
        state.isLoadingImages = true;
      })
      .addCase(fetchVehicleImages.fulfilled, (state, action) => {
        const data = action.payload;

       /* const sortedImages = data.sort((a, b) => {
          if (a.type === 'exterior' && b.type !== 'exterior') {
            return -1;
          }
          if (a.type !== 'exterior' && b.type === 'exterior') {
            return 1;
          }
          if (a.type === 'interior' && b.type !== 'interior') {
            return -1;
          }
          if (a.type !== 'interior' && b.type === 'interior') {
            return 1;
          }
          return 0;
        });*/

        state.isLoadingImages = false;
        state.vehicleImages = data;
      })
      .addCase(fetchVehicleImages.rejected, (state) => {
        state.isLoadingImages = false;
      })
      .addCase(uploadVehicleImage.fulfilled, (state, action) => {
        const newVehicle = action.payload;
        state.vehicleImages.unshift(newVehicle);
      })
      .addCase(editVehicleImage.fulfilled, (state, action) => {
        const editVehicle = action.payload;
        const index = state.vehicleImages.findIndex(
          (vehicle) => vehicle.id === editVehicle.id
        );

        if (index !== -1) {
          const previousType = state.vehicleImages[index].type;
          state.vehicleImages[index] = editVehicle;

          /*if (previousType !== editVehicle.type) {
            state.vehicleImages = state.vehicleImages.sort((a, b) => {
              if (a.type === 'exterior' && b.type !== 'exterior') {
                return -1;
              }
              if (a.type !== 'exterior' && b.type === 'exterior') {
                return 1;
              }
              if (a.type === 'interior' && b.type !== 'interior') {
                return -1;
              }
              if (a.type !== 'interior' && b.type === 'interior') {
                return 1;
              }
              return 0;
            });
          }*/
        }
      })
      .addCase(removeVehicleImage.fulfilled, (state, action) => {
        const imageId = action.payload;
        state.vehicleImages = state.vehicleImages.filter(
          (image) => image.id !== imageId
        );
      })
      .addCase(fetchVehicleImagesBrands.pending, (state) => {
        state.isLoadingImages = true;
      })
      .addCase(fetchVehicleImagesBrands.fulfilled, (state, action) => {
        const data = action.payload;
        state.isLoadingImages = false;
        state.vehicleImages = data;
      })
      .addCase(fetchVehicleImagesBrands.rejected, (state) => {
        state.isLoadingImages = false;
      })
  },
});

export const vehicleImageActions = vehicleImageSlice.actions;

export default vehicleImageSlice;
